import React from 'react';
import * as s from './styled-tip-logo-higra';
import { icons } from '../../assets/index';

const TipLogotipoHygra = () => {
  return (
    <s.Box>
      <img src={icons.LogotipoBlue} alt="" />
    </s.Box>
  );
};

export default TipLogotipoHygra;
